import { ApolloClient } from "apollo-boost";
import gql from "graphql-tag";

type StyleCodeOwner = {
    styleCode: string;
    inventoryItemId: number;
}

const GetItemIdByStyleCodeQuery = gql`
    query GetItemIdByStyleCode($styleCode: String!) {
        inventoryListing(styleCode: $styleCode) {
            inventoryItemId
            styleCode
        }
    }`;

class InventoryCatalog {
    private _apollo: ApolloClient<any>;

    constructor(apollo: ApolloClient<any>) {
        this._apollo = apollo;
    }

    async getStyleCodeOwner(styleCode: string): Promise<StyleCodeOwner | null> {
       const res = await this._apollo.query({
            query: GetItemIdByStyleCodeQuery,
            variables: { styleCode }
        });

        return res.data.inventoryListing;
    }

}

export default InventoryCatalog;
